import styled from 'styled-components';

// *** Components ***
export const XingLogo = styled.div``;
